import { ENDPOINTS } from "../../apiConfig";
import axiosRequest from "../universal/axiosService";
// import axiosRequest from "../universal/axiosService";
// import axiosRequest from "../universal/axiosService";

export const fetchJobsApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.JOB.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const fetchTotalJobsCountApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.JOB.GET_TOTAL_COUNT,
    params: {
      ...params,
    },
  });
};
export const updateJobApi = async ({ coll, uiid, payload, id }) => {
  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.JOB.UPDATE,
    data: { payload },
    params: { coll, uiid, id },
  });
};
